import styled from 'styled-components'

const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  height: 4rem;
  line-height: 4rem;
  border-bottom: 3px solid lightgrey;
  padding-inline-start: 1em;
  text-align: left;
`

export default ListItem;
